<template>
  <div style="display: flex; gap: 8px">
    <button
      v-if="showNoteBtn"
      class="btn small primary outline download-button"
      style="padding: 8px 8px 10px 9px; border-radius: 5px"
      @click="$emit('openNoteDialog')"
    >
      <i style="height: 14px; display: block">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
            stroke="#357456"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 8V13"
            stroke="#357456"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9945 16H12.0035"
            stroke="#357456"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </i>
    </button>
    <el-dropdown trigger="click" @command="handleCommand">
      <button
        class="btn small primary outline download-button"
        style="padding: 8px 9px; border-radius: 5px"
      >
        <i class="el-icon-download"></i>
      </button>
      <el-dropdown-menu>
        <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
        <el-dropdown-item command="excel">Xuất Excel</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <button class="btn primary small">Xuất Excel</button> -->
  </div>
</template>

<script>
export default {
  props: {
    showNoteBtn: {
      type: Boolean,
      default: true
    },
    exportExcel: null
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd === 'excel') {
        this.$emit('exportExcel')
      }
    }
  }
}
</script>

<style></style>
